import TextInput from "../../../components/UIComponent/TextInput";
import ModalBasic from "../../component/ModalBasic";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import MultiSelectDropdown from "../../../components/dropdown/MultiSelectDropdown";

export const table2Data = [];
export const table2ColDefs = [];

export const EmployeeSalaryPopUp = (props) => {
    return (
        <ModalBasic
            id="salaryBankTransfer"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}>
            <div className="input-fields p-[30px]">
                <div className="item-grp">
                    <span className="text-blue text-[16px] font-semibold">Employee basic details</span>
                    <div className="item-inner grid grid-cols-4 gap-2.5 mt-[5px] mb-3">
                        <div className="input-grp">
                            <label>Voucher no</label>
                            <TextInput type="number" id="voucherNo" name="voucherNo"
                                value={props.employeeBasicDetails.voucherNo}
                                handleChange={(event) => props.handleChange(event, "voucherNo")}
                                disabled
                            />
                        </div>
                        <div className="input-grp">
                            <label>Date</label>
                            <TextInput type="date" id="date"
                                name="date"
                                value={props.employeeBasicDetails.date}
                                handleChange={(event) => props.handleChangeForEmployeeBasicDetails(event, "date")}
                                className={props.validState?.error?.date !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp col-span-2">
                            <label>Acc. sub head</label>
                            <MultiSelectDropdown
                                className={` ${props.validState?.error?.accSubHeadId ? "error" : ""}`}
                                options={props.employeeBasicDetails.generalProducts}
                                value={props.employeeBasicDetails.accSubHeadId ? props.employeeBasicDetails.generalProducts?.find(item => item.value === props.employeeBasicDetails.accSubHeadId) : 0}
                                onChange={(event) =>
                                    props.handleChangeFroDropdown(
                                        event,
                                        "accSubHeadId"
                                    )
                                }
                            />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-4 gap-2.5 pb-[12px] mb-2.5 border-b border-slate-200">
                        <div className="input-grp">
                            <label>From date</label>
                            <TextInput type="date" id="fromDate" name="fromDate"
                                value={props.employeeBasicDetails.fromDate}
                                handleChange={(event) => props.handleChangeForEmployeeBasicDetails(event, "fromDate")}
                                className={props.validState?.error?.fromDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>To date</label>
                            <TextInput type="date" id="toDate" name="toDate"
                                value={props.employeeBasicDetails.toDate}
                                handleChange={(event) => props.handleChangeForEmployeeBasicDetails(event, "toDate")}
                                className={props.validState?.error?.toDate !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp col-span-2">
                            <label>Authorised by</label>
                            <MultiSelectDropdown
                                className={props.validState?.error?.authorisedById !== undefined ? "error" : ""}
                                options={props.employeeBasicDetails.employeeList}
                                //value={props.employeeBasicDetails.authorisedById}
                                value={props.employeeSalaryDetails.authorisedById ? props.employeeBasicDetails.employeeList?.find(item => item.value === props.employeeBasicDetails.authorisedById) : 0}
                                onChange={(event) =>
                                    props.handleChangeFroDropdown(
                                        event,
                                        "authorisedById"
                                    )
                                }
                            />
                        </div>
                    </div>
                    <span className="text-blue text-[16px] font-semibold">Salary details</span>
                    <div className="item-inner grid grid-cols-2 gap-2.5 mb-3 mt-2.5">
                        <div className='input-grp'>
                            <label>Select employee</label>
                            <MultiSelectDropdown
                                className={props.validState?.error?.idEmployee !== undefined ? "error" : ""}
                                options={props.employeeBasicDetails.employeeList}
                                value={props.employeeSalaryDetails.idEmployee ? props.employeeBasicDetails.employeeList?.find(item => item.value === props.employeeSalaryDetails.idEmployee) : 0}
                                // value={props.employeeSalaryDetails.idEmployee}
                                onChange={(event) =>
                                    props.handleChangeFroDropdown(
                                        event,
                                        "idEmployee"
                                    )
                                }
                            />
                        </div>
                        <div className="inputOuter-grp grid grid-cols-3 gap-2.5">
                            <div className="input-grp">
                                <label>Total days</label>
                                <TextInput type="number" id="totalDays" name="totalDays"
                                    value={props.employeeSalaryDetails.totalDays}
                                    handleChange={(event) => props.handleChange(event, "totalDays")}
                                    className={props.validState?.error?.totalDays !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className="input-grp">
                                <label>Working days</label>
                                <TextInput type="number" id="workingDays" name="workingDays"
                                    value={props.employeeSalaryDetails.workingDays}
                                    handleChange={(event) => props.handleChange(event, "workingDays")}
                                    className={props.validState?.error?.workingDays !== undefined ? "error" : ""}
                                />
                            </div>
                            <div className="input-grp">
                                <label>Week off days</label>
                                <TextInput type="number" id="weekOffDays" name="weekOffDays"
                                    value={props.employeeSalaryDetails.weekOffDays}
                                    handleChange={(event) => props.handleChange(event, "weekOfDays")}
                                    className={props.validState?.error?.weekOfDays !== undefined ? "error" : ""}
                                    disabled
                                />
                            </div>
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-6 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>Basic salary</label>
                            <TextInput type="number" id="basicSalary" name="basicSalary"
                                value={props.employeeSalaryDetails.basicSalary}
                                handleChange={(event) => props.handleChange(event, "basicSalary")}
                                disabled
                            />
                        </div>
                        <div className="input-grp">
                            <label>HRA amount</label>
                            <TextInput type="number" id="hraAmt" name="hraAmt"
                                value={props.employeeSalaryDetails.hraAmt}
                                handleChange={(event) => props.handleChange(event, "hraAmt")}
                                className={props.validState?.error?.hraAmt !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Conv. amount</label>
                            <TextInput type="number" id="convAmt" name="convAmt"
                                value={props.employeeSalaryDetails.convAmt}
                                handleChange={(event) => props.handleChange(event, "convAmt")}
                                className={props.validState?.error?.convAmt !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Sp. allow</label>
                            <TextInput type="number" id="spAllow" name="spAllow"
                                value={props.employeeSalaryDetails.spAllow}
                                handleChange={(event) => props.handleChange(event, "spAllow")}
                                className={props.validState?.error?.spAllow !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Gross Salary</label>
                            <TextInput type="number" id="grossSalary" name="grossSalary"
                                value={props.employeeSalaryDetails.grossSalary}
                                handleChange={(event) => props.handleChange(event, "grossSalary")}
                                disabled
                            />
                        </div>
                        <div className="input-grp">
                            <label>PF</label>
                            <TextInput type="number" id="pf" name="pf"
                                value={props.employeeSalaryDetails.pf}
                                handleChange={(event) => props.handleChange(event, "pf")}
                                className={props.validState?.error?.pf !== undefined ? "error" : ""}
                            />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-6 gap-2.5 mb-3">
                        <div className="input-grp">
                            <label>ESIC</label>
                            <TextInput type="number" id="esic" name="esic"
                                value={props.employeeSalaryDetails.esic}
                                handleChange={(event) => props.handleChange(event, "esic")}
                                className={props.validState?.error?.esic !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>PT</label>
                            <TextInput type="number" id="pt" name="pt"
                                value={props.employeeSalaryDetails.pt}
                                handleChange={(event) => props.handleChange(event, "pt")}
                                className={props.validState?.error?.pt !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Loan amount</label>
                            <TextInput type="number" id="loanAmt" name="loanAmt"
                                value={props.employeeSalaryDetails.loanAmt}
                                handleChange={(event) => props.handleChange(event, "loanAmt")}
                                disabled
                            />
                        </div>
                        <div className="input-grp">
                            <label>Deduct amount</label>
                            <TextInput type="number" id="deductAmt" name="deductAmt"
                                value={props.employeeSalaryDetails.deductAmt}
                                handleChange={(event) => props.handleChange(event, "deductAmt")}
                                className={props.validState?.error?.deductAmt !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Net payble</label>
                            <TextInput type="number" id="monthlySalary" name="monthlySalary"
                                value={props.employeeSalaryDetails.monthlySalary}
                                handleChange={(event) => props.handleChange(event, "monthlySalary")}
                                className={props.validState?.error?.monthlySalary !== undefined ? "error" : ""}
                            />
                        </div>
                        <div className="input-grp">
                            <label>TDS</label>
                            <TextInput type="number" id="tds" name="tds"
                                value={props.employeeSalaryDetails.tds}
                                handleChange={(event) => props.handleChange(event, "tds")}
                                className={props.validState?.error?.tds !== undefined ? "error" : ""}
                            />
                        </div>
                    </div>
                    <div className="item-inner grid grid-cols-6 gap-2.5 mb-3">
                        <div className="input-grp col-span-2">
                            <label>Remarks</label>
                            <TextInput type="text" id="remarks" name="remarks"
                                value={props.employeeSalaryDetails.remarks}
                                handleChange={(event) => props.handleChange(event, "remarks")}
                            />
                        </div>
                        <div className="input-grp">
                            <label>Total cheque amount</label>
                            <TextInput type="number" id="totalChequeAmt" name="totalChequeAmt"
                                value={props.employeeBasicDetails.totalChequeAmt}
                                handleChange={(event) => props.handleChange(event, "totalChequeAmt")}
                                disabled
                            />
                        </div>
                        {props.employeeSalaryDetails && props.employeeSalaryDetails.index === null ?
                            <div className="input-grp">
                                <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.insertItem("Insert")}> Insert</button>
                            </div>
                            :
                            <div className="input-grp flex items-center gap-2.5">
                                <button className="save-btn btns mt-auto mb-[2px]" onClick={() => props.insertItem("Update")}> Update</button>
                                <button className="delete-btn btns mt-auto mb-[2px]" onClick={() => props.deleteItem()}> Delete</button>
                            </div>
                        }
                    </div>
                    <div className="ledger-table h-[25vh] pb-[12px]">
                        <div className="table-inner h-full">
                            <AgGridReact
                                rowData={props.salaryRowData}
                                columnDefs={props.salaryColdefs}
                                onCellClicked={props.onRowDoubleClickedForSalaryDetails}
                            />
                        </div>
                    </div>
                    <div className="btn-grp inline-flex gap-2.5">
                        <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    );
}